import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { ArrowUpRight } from "lucide-react";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import { useNavigate } from "react-router-dom";
import { decryptToken } from "../utils/getToken";

const InfoDashboard = () => {
    const [customers, setCustomers] = useState([]);
    const [leads, setLeads] = useState([]);
    const [invoices, setInvoices] = useState([]);
    const [expenses, setExpenses] = useState([]);
    const [users, setUsers] = useState([]);
    const [products, setProducts] = useState([]);
    const [orders, setOrders] = useState([]);
    const navigate = useNavigate();
    const token = decryptToken("accessToken") || ""
    const url = process.env.REACT_APP_LINK;
    const user = getDecryptedUserFromCookie("gta_mainstateuser");

    useEffect(() => {
        if (!user?.main_id) return;

        fetch(`${url}/api/customer/all/${user.main_id}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(res => res.json()).then(setCustomers);
        fetch(`${url}/leads/all/${user.main_id}`,{
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(res => res.json()).then(setLeads);
        fetch(`${url}/newinvoice/all/${user.main_id}`,{
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(res => res.json()).then(setInvoices);
        fetch(`${url}/api/expenses/all/${user.main_id}`,{
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(res => res.json()).then(setExpenses);
        fetch(`${url}/registeruser/getdata/${user.main_id}`,{
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(res => res.json()).then(setUsers);
        fetch(`${url}/grouped-product/search-all-products/${user.main_id}`,{
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(res => res.json()).then(setProducts);
        fetch(`${url}/payment/adminorder/${user.main_id}`,{
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(res => res.json()).then(setOrders);
    }, [user?.main_id]);

    const dashboardData = [
        { title: "CRM", route: "/crm", bg: "bg-blue-100", text: "text-blue-600", count: leads.length },
        { title: "Customer", route: "/customer", bg: "bg-green-100", text: "text-green-600", count: customers.length },
        { title: "Invoice", route: "/invoice", bg: "bg-yellow-100", text: "text-yellow-600", count: invoices.length },
        { title: "Expense", route: "/expense", bg: "bg-red-100", text: "text-red-600", count: expenses.length },
        { title: "Products", route: "/products", bg: "bg-indigo-100", text: "text-indigo-600", count: products.length },
        { title: "Orders", route: "/orders", bg: "bg-purple-100", text: "text-purple-600", count: orders.length },
    ];

    return (
        <div className="my-12 rounded-lg shadow-md p-4">
            <h2 className="text-[18px] font-semibold text-gray-800 mb-2">Overview</h2>
            <Marquee pauseOnHover gradient={false} speed={50} className="space-x-4">
                {dashboardData.map((item, index) => (
                    <div
                        key={index}
                        onClick={() => navigate(item.route)}
                        className={`min-w-[160px] mr-4 p-2 rounded-lg shadow cursor-pointer flex justify-between items-center transition-transform hover:scale-[1.03] ${item.bg} ${item.text}`}
                    >
                        <div>
                            <h3 className="text-sm font-semibold">{item.title}</h3>
                            <p className="text-xl font-bold">{item.count}</p>
                        </div>
                        <div className="bg-white text-black p-1 rounded-full">
                            <ArrowUpRight size={18} />
                        </div>
                    </div>
                ))}
            </Marquee>
        </div>
    );
};

export default InfoDashboard;
